import React from "react"
import { Grid, Row, Col } from "react-bootstrap"
import { Log } from "../lib/logger"

import LoadImages from "./LoadImages"
// import EditImages from "./EditImages"
import ImageThumbnailSelector from "./ImageThumbnailSeletor"
import ImageThumbnailsDownload from "./ImageThumbnailsDownload"
import ImageCropSelector from "./ImageCropSelector"

class App extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            sourceFiles: [],
            selectedSourceFileImageMd5ForEdit: null,
            cropPolygonX: null,
            cropPolygonY: null,
            cropPolygonRadius: null,
            cropPolygonRotation: null,
            croppedImages: [],
            generateCrop: false,
            nudgeFromLoadImages: false,
            nudgeFromSelectImages: false,
            nudgeFromCropImage: false,
            okIGotItWithTheNudgingStopNow: false,
            scrollToImageCropSelector: false,
            scrollToImageThumbnailsDownload: false
        }
        Log().info("Started app")
    }

    onFileLoaded = (sourceFile) => {
        this.setState(prevState => {
            return {
                sourceFiles: [...prevState.sourceFiles, sourceFile],
                nudgeFromLoadImages: !prevState.okIGotItWithTheNudgingStopNow
            }
        })
    }

    onSingleFileLoaded = () => {
        this.setState(prevState => {
            return { 
                selectedSourceFileImageMd5ForEdit: prevState.sourceFiles[0].imageMd5, 
                nudgeFromLoadImages: false,
                scrollToImageCropSelector: !prevState.okIGotItWithTheNudgingStopNow && (!prevState.sourceFiles || prevState.sourceFiles.length === 0)
            }})
    }
    onScrolledToImageCropSelector = () => {
        this.setState({scrollToImageCropSelector: false})
    }

    onScrolledToImageThumbnailsDownload = () => {
        this.setState({scrollToImageThumbnailsDownload: false})
    }

    onSelectImageClicked = (imageMd5) => {
        Log().info(`Selected image ${imageMd5}`)
        this.setState(prevState => {
            return { 
                selectedSourceFileImageMd5ForEdit: imageMd5, 
                nudgeFromLoadImages: false,
                nudgeFromSelectImages: !prevState.okIGotItWithTheNudgingStopNow
            }})
    }

    onNewCroppedImage = (newImage, newPolygonX, newPolygonY, newPolygonRadius, newPolygonRotation, lastCroppedSourceFileImageMd5) => {
        this.setState(prevState => {
            return { 
                croppedImages: [newImage, ...prevState.croppedImages], 
                cropPolygonX: newPolygonX, 
                cropPolygonY: newPolygonY, 
                cropPolygonRadius: newPolygonRadius, 
                cropPolygonRotation: newPolygonRotation, 
                lastCroppedSourceFileImageMd5, 
                generateCrop: false,
                nudgeFromSelectImages: false,
                nudgeFromCropImage: !prevState.okIGotItWithTheNudgingStopNow,
                scrollToImageThumbnailsDownload: !prevState.okIGotItWithTheNudgingStopNow
            }
        })
        Log().timeEnd(`Creating ${this.state.polygonNumberOfSides}-agon crop of ${lastCroppedSourceFileImageMd5}`)
    }

    onGenerateCrop = (cropParameters) => {
        this.setState({...cropParameters, scrollToImageThumbnailsDownload: true})
    }

    onImageDownloaded = () => {
        this.setState({
            nudgeFromCropImage: false,
            okIGotItWithTheNudgingStopNow: true,
            scrollToImageThumbnailsDownload: false
        })
        Log().info(`Downloaded croppped image of ${this.state.lastCroppedSourceFileImageMd5}`)
    }

    render() {
        return (
            <Grid>
                <Row>
                    <Col md={12}>
                        <h1 className="title">Polygonal image crop</h1>
                        <LoadImages sourceFiles={this.state.sourceFiles} 
                            nudgeFromLoadImages={this.state.nudgeFromLoadImages}
                            onFileLoaded={this.onFileLoaded}
                            onSingleFileLoaded={this.onSingleFileLoaded} />
                        <ImageThumbnailSelector
                            sourceFiles={this.state.sourceFiles}
                            onSelectImageClicked={this.onSelectImageClicked}
                            nudgeFromSelectImages={this.state.nudgeFromSelectImages}
                            selectedSourceFileImageMd5ForEdit={this.state.selectedSourceFileImageMd5ForEdit} />
                        <ImageCropSelector
                            selectedSourceFileImageMd5ForEdit={this.state.selectedSourceFileImageMd5ForEdit} 
                            lastCroppedSourceFileImageMd5={this.state.lastCroppedSourceFileImageMd5}
                            sourceFiles={this.state.sourceFiles}
                            cropPolygonX={this.state.cropPolygonX}
                            cropPolygonY={this.state.cropPolygonY}
                            cropPolygonRadius={this.state.cropPolygonRadius}
                            cropPolygonRotation={this.state.cropPolygonRotation}
                            onGenerateCrop={this.onGenerateCrop}
                            generateCrop={this.state.generateCrop}
                            nudgeFromCropImage={this.state.nudgeFromCropImage}
                            scrollToImageCropSelector={this.state.scrollToImageCropSelector}
                            onScrolledToImageCropSelector={this.onScrolledToImageCropSelector}
                            onNewCroppedImage={this.onNewCroppedImage} />
                        <ImageThumbnailsDownload
                            croppedImages={this.state.croppedImages}
                            scrollToImageThumbnailsDownload={this.state.scrollToImageThumbnailsDownload}
                            onScrolledToImageThumbnailsDownload={this.onScrolledToImageThumbnailsDownload}
                            onImageDownloaded={this.onImageDownloaded} />
                        <span style={{ marginLeft: "3px", fontSize: "xx-small" }}>
                            Version: 2018-06-09 14:07
                        </span>
                    </Col>
                </Row>
            </Grid>
        )
    }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.jsx